
import React from "react";
import { createPortal } from "react-dom";
import Loader from "react-loader-advanced";
import FontAwesome from "react-fontawesome";
import _ from "lodash";

const _Loader = ({ message, ...props}) => {
	const _message = (message) ? message :
		<FontAwesome
			name='spinner'
			size='4x'
			spin />;
	
	const _props = _.assign({}, {
		style: { margin: "0px", padding: "0px" },
		className: "col-xs-12",
		backgroundStyle: { overflow: "auto", height: "calc(100% - 20px)", borderRadius: "4px" },
		message:_message
	}, props);

	
	if (_props.panel && props.show) {
		delete _props.style;
		_props.className = "panelLoader";
	} else if (_props.modal && props.show) {
		delete _props.style;
		_props.className = "modalLoader";
	} else if (_props.fullPage && props.show) {
		delete _props.style;
		_props.className = "fullPageLoader";
	}

	let comp = (props.children) ? (
		<Loader {..._props}>
			{props.children}
		</Loader>
	) : (
		<Loader {..._props}><span/></Loader>
	);

	return _props.fullPage ? createPortal(comp, document.body) : comp;
};

export default _Loader;